// @ts-strict-ignore
import { createSelector } from 'reselect';

import type { CanvasSize } from 'flow/service/graph';

import type { State } from '~/store';

export const selectCanvasSize = createSelector(
  [
    (state: State) => state.workflowEditor.ui.canvasProperties.rect.width,
    (state: State) => state.workflowEditor.ui.canvasProperties.rect.height,
  ],
  (width, height): CanvasSize => ({ width, height }),
);


export const selectCanvasPosition = createSelector(
  [
    (state: State) => state.workflowEditor.ui.canvasProperties.rect.x,
    (state: State) => state.workflowEditor.ui.canvasProperties.rect.y,
    (state: State) => state.workflowEditor.ui.canvasProperties.rect.zoom,
  ],
  (x, y, zoom) => ({ x, y, zoom }),
);


export const selectCanvasRect = createSelector(
  [
    selectCanvasSize,
    selectCanvasPosition,
  ],
  (
    canvasSize,
    canvasPosition,
  ) => ({
    ...canvasSize,
    ...canvasPosition,
  }),
);

